module.exports = __webpack_public_path__ + "static/assets/852d87e53ef8837fc17762f0c36ba37b.svg";